module.exports = __webpack_public_path__ + "static/media/caret_down.e925e832.svg";